const MyFidelityTree = () => {
    return (
        <div>
            <h1>My Fidelity Tree</h1>
        </div>
    );
};

export default MyFidelityTree;
